/** Lab Rate button — one updateManyHorse with per-runner lay (no parallel horseEdit race). */

type RateButtonRunner = {
  _id: string
  id?: string
  selectionId?: string
  back: number | null
  status: boolean
}

export function buildRateButtonUpdateManyBody(
  market: {
    _id: string
    id?: string
    betfairId?: string
    runners: RateButtonRunner[]
  },
  rateData: number,
  drafts: Record<string, number | null | undefined> = {},
): Record<string, unknown> {
  const betfairId = String(market.betfairId ?? market.id ?? '')
  return {
    marketId: market._id,
    _id: market._id,
    id: betfairId,
    betfairId,
    runners: market.runners.map((runner) => {
      const key = String(runner.id ?? runner._id ?? runner.selectionId ?? '').trim()
      const draft = drafts[runner._id]
      const backVal = draft != null ? draft : runner.back
      const status = runner.status ? 'Enable' : 'Disable'
      if (backVal != null && !Number.isNaN(Number(backVal))) {
        const back = Number(backVal)
        return {
          id: key || runner._id,
          _id: runner._id,
          back,
          lay: Number((back + rateData).toFixed(2)),
          ratebuttonData: rateData,
          status,
        }
      }
      return {
        id: key || runner._id,
        _id: runner._id,
        back: null,
        lay: null,
        ratebuttonData: rateData,
        status,
      }
    }),
  }
}
